import Space from 'antd/es/space';

export default Space;
